import { Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

const ShareOptions = () => {
  const tooltipList = [
    "You’ll earn 5% on the first payment and every renewal while both accounts remain active.",
    "Earnings are pending for 30 days to protect against refunds or chargebacks.",
    "Minimum payout: $25. Requests are processed within 5 business days.",
    "No self‑referrals. Fraudulent activity will be reversed and accounts may be suspended."
  ];

  return (
    <div className="share-info">
      <span className="info-title">Quick rules & FAQs</span>
      <Tooltip
      overlayClassName="info-tooltip"
        title={
          <ul style={{ paddingLeft: 20, margin: 0 }}>
            {tooltipList.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        }
        placement="top"
      >
        <InfoCircleOutlined style={{ color: "#1890ff", cursor: "pointer" }} />
      </Tooltip>
    </div>
  );
};

export default ShareOptions;
